import { render } from "./LoginSample.vue?vue&type=template&id=bc0ce4a6"
import script from "./LoginSample.vue?vue&type=script&lang=js"
export * from "./LoginSample.vue?vue&type=script&lang=js"

import "./LoginSample.vue?vue&type=style&index=0&id=bc0ce4a6&lang=css"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__